import React, { useEffect, useState } from "react";
import Menu from "../Menu";
import Header from "../Header";
import Footer from "../Footer";
import { Select, Spin } from "antd";
import { Table, Space } from "antd";
import { Config } from "../../config/config";
import Spinner from "../../helpers/shared/Spinner";
import MessageBox from "../../UIComponents/MessageBox/MessageBox";
import Cookie from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  doGetAssetsList,
  getSelectedAsset,
  assetCreate,
  assetEdit,
  doUpdateAssetPic,
  getSelectedAssetSubCategory,
  DeleteAssetDetails,
} from "./actions/assetsService";
import AddAsset from "./AddAsset";
import EditAsset from "./EditAsset";
import * as XLSX from "xlsx";
import LZString from "lz-string";
import { assetFileUploadApi, assetFileUploadModalSubTitle, assetFileUploadModalTitle, assetTitle, fileUploadModalSubTitle, fileUploadModalTitle } from "../../constants/Constants";
import FileUploadModal from "../../helpers/shared/FileUploadModal";
import useFileUploadModal from "../../../hooks/useFileUploadModal";
import AssetBulkUploadBody from "./AssetBulkUploadBody";
const config = JSON.parse(Config);
const apiInterface4 = config["api4"];

const { Option } = Select;

export default function AssetsList() {
  const { handleCancel, openModal, visible } = useFileUploadModal();
  const assetsList = useSelector((state) => state?.assetList?.AssetsDetail);
  const status = useSelector((state) => state?.assetList);
  const selectedAsset = useSelector(
    (state) => state?.assetList?.SelectedAssetsDetail
  );
  const assetDetails = useSelector((state) => state?.assetList?.AssetsDetail);
  const AllowAssets = useSelector(
    (state) => state?.assetList?.AssetsDetail?.AllowAssets[0]
  );
  console.log(AllowAssets, "AllowAssets");
  const dispatch = useDispatch();
  const [assetImage, setAssetImage] = useState("");
  const jsonData = Cookie.get("currentUser");
  let decompressedData = LZString.decompressFromBase64(jsonData);
  decompressedData =
    decompressedData == "\x00\x00\x00" ? jsonData : decompressedData;
  const user = JSON.parse(decompressedData);
  let userID = user["userId"];
  const apiInterface = config["api1"];
  const TableColumns = [
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <div className="table-icons">
            <i
              className="fa fa-eye orange"
              aria-hidden="true"
              onClick={() => _getRowData(record)}
            ></i>
            {AllowAssets?.allow_edit == 1 && (
              <i
                className="fa fa-pencil blue"
                onClick={() => edit(record)}
                aria-hidden="true"
              ></i>
            )}
            {AllowAssets?.allow_edit == 1 && (
              <i
                className="fa fa-trash blue"
                onClick={() =>
                  dispatch(
                    DeleteAssetDetails({
                      assetId: record?.asset_id,
                      storeId: record?.store_id,
                    })
                  )
                }
                aria-hidden="true"
              ></i>
            )}
          </div>
        </Space>
      ),
    },
    {
      title: "Lot",
      dataIndex: "lot",
      key: "Lot",
      width: 80,
    },
    {
      title: "Sub Category",
      dataIndex: "sub_category_name",
      key: "SubCategory",
    },
    {
      title: "Asset Name",
      dataIndex: "asset_name",
      key: "AssetName",
    },
    {
      title: "Store Name",
      dataIndex: "store_name",
      key: "Vendor",
    },
    {
      title: "Availability",
      dataIndex: "available",
      key: "Available",
    },
  ];
  const [isAmc, setIsAmc] = useState(false);
  const [isDescriptionDetails, setIsDescriptionDetails] = useState(false);
  const [tableData, setTableData] = useState();
  const [searchedItem, setSearchedItem] = useState({
    main_category: [],
    sub_Category: [],
    vendor: [],
    store: [],
    status: "",
  });
  const [subCategory, setSubCategory] = useState([]);

  const [fileList, setFileList] = useState([]);
  const [storeSelectedForBulkUpload, setStoreSelectedForBulkUpload] = useState(
    {}
  );
  const exportToExcel = (tableData) => {
    const wb = XLSX.utils.book_new();
    const wsData = [
      [
        "Asset Ref",
        "Store Name",
        "Sub Category Name",
        "Asset Name",
        "Lot",
        "Available",
        "Location",
        "Make",
        "Model Number",
        "Serial Number",
        "Capacity Type",
        "Capacity Value",
        "Installation Date",
        "Warranty",
        "Total Number",
        "Vendor Company Name",
        "Vendor Code",
        "Mobile number",
        "Email Address",
      ],
      ...tableData.map((item) => [
        item.asset_ref,
        item.store_name,
        item.sub_category_name,
        item.asset_name,
        item.lot,
        item.available,
        item.location,
        item.make,
        item.model_no,
        item.serial_no,
        item.capacity_type,
        item.capacity_value,
        item.installation_date,
        item.warranty,
        item.total_no,
        item.vendor_company_name,
        item.vendor_code,
        item.mobile_number1,
        item.email_address1,
      ]),
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Asset List");
    XLSX.writeFile(wb, "AssetListReport.xlsx");
  };
  const _doNavToAddAsset = () => {
    dispatch(assetCreate(true));
  };
  const edit = (item) => {
    let filteredData = assetDetails?.SubCategory.filter(
      (ele) => ele.id == item.sub_category_id
    );
    dispatch(getSelectedAssetSubCategory(filteredData[0]));
    dispatch(getSelectedAsset(item));
    dispatch(assetEdit(true));
  };

  const _getRowData = (item) => {
    dispatch(getSelectedAsset(item));
    let filteredData = assetDetails?.SubCategory.filter(
      (ele) => ele.id == item.sub_category_id
    );
    dispatch(getSelectedAssetSubCategory(filteredData[0]));
  };
  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setAssetImage(reader.result);
      let data = {
        fedid: userID,
        update_row_id: selectedAsset?.asset_id,
        update_type: "2",
        filename: file.name,
        file: reader.result.toString().replace(/^data:(.*,)?/, ""),
      };
      dispatch(doUpdateAssetPic(data));
    };
    reader.onerror = (error) => console.log(error);
  };
  const _doSelectVender = (value) => {
    setSubCategory(
      assetsList?.SubCategory?.filter((ele) => {
        if (value.includes(ele.maintenance_maincategory_id)) {
          return ele;
        }
      })
    );
  };
  useEffect(() => {
    if (
      searchedItem.main_category.length != 0 ||
      searchedItem.sub_Category.length != 0 ||
      searchedItem.vendor.length != 0 ||
      searchedItem.store.length != 0 ||
      searchedItem.status.length != 0
    ) {
      handleSearch();
    } else {
      setTableData(assetsList?.AssetsList);
    }
  }, [assetsList]);
  const handleSearch = () => {
    var arr = [];
    setTableData([]);
    if (
      searchedItem.vendor == "" &&
      searchedItem.sub_Category == "" &&
      searchedItem.main_category == "" &&
      searchedItem.store == "" &&
      searchedItem.status == ""
    ) {
      var fetcheddata = assetsList?.AssetsList.filter((ele) => ele);
      setTableData(fetcheddata);
    } else {
      //four conditions
      if (
        searchedItem.main_category.length != 0 &&
        searchedItem.sub_Category.length != 0 &&
        searchedItem.vendor.length != 0 &&
        searchedItem.store.length != 0
      ) {
        var sub = [];
        for (let i = 0; i < searchedItem.sub_Category.length; i++) {
          fetcheddata = assetsList?.AssetsList.filter(
            (ele) => ele.sub_category_id == searchedItem.sub_Category[i]
          ).map((data) => sub.push(data));
        }
        console.log(sub, "sub");
        var vend = [];
        for (let i = 0; i < searchedItem.vendor.length; i++) {
          fetcheddata = sub
            .filter((ele) => ele.vendor_id == searchedItem.vendor[i])
            .map((data) => vend.push(data));
        }
        console.log(vend, "vend");
        var sto = [];
        for (let i = 0; i < searchedItem.store?.length; i++) {
          fetcheddata = vend
            .filter((ele) => ele.store_name == searchedItem.store[i])
            .map((data) => sto.push(data));
        }
        if (searchedItem.status.length != 0) {
          if (searchedItem.status == "ALL") {
            setTableData(sto);
          } else {
            fetcheddata = sto.filter(
              (ele) => ele.available == searchedItem.status
            );
            setTableData(fetcheddata);
          }
        } else {
          console.log(sto, "inside else block of store");
          setTableData(sto);
        }
      }
      //three conditions
      else if (
        searchedItem.main_category.length != 0 &&
        searchedItem.sub_Category.length != 0 &&
        searchedItem.store.length != 0
      ) {
        console.log("two fields selected");
        var sub = [];
        for (let i = 0; i < searchedItem.sub_Category.length; i++) {
          fetcheddata = assetsList.AssetsList.filter(
            (ele) => ele.sub_category_id == searchedItem.sub_Category[i]
          ).map((data) => sub.push(data));
        }
        var sto = [];
        console.log(searchedItem.store, "store");
        for (let i = 0; i < searchedItem.store.length; i++) {
          fetcheddata = sub
            .filter((ele) => ele.store_name == searchedItem.store[i])
            .map((data) => sto.push(data));
        }
        if (searchedItem.status.length != 0) {
          if (searchedItem.status == "ALL") {
            setTableData(sto);
          } else {
            fetcheddata = sto.filter(
              (ele) => ele.available == searchedItem.status
            );
            setTableData(fetcheddata);
          }
        } else {
          console.log(sto, "inside else block of store");
          setTableData(sto);
        }
      } else if (
        searchedItem.main_category.length != 0 &&
        searchedItem.sub_Category.length != 0 &&
        searchedItem.vendor.length != 0
      ) {
        console.log("show data");
        console.log(searchedItem.sub_Category, "sub_Category");
        var sub = [];
        for (let i = 0; i < searchedItem.sub_Category.length; i++) {
          fetcheddata = assetsList.AssetsList.filter(
            (ele) => ele.sub_category_id == searchedItem.sub_Category[i]
          ).map((data) => sub.push(data));
        }
        console.log(searchedItem.vendor, "vendor");
        console.log(sub, "sub");
        var ven = [];
        for (let i = 0; i < searchedItem.vendor.length; i++) {
          fetcheddata = sub
            .filter((ele) => ele.vendor_id == searchedItem.vendor[i])
            .map((data) => ven.push(data));
        }
        if (searchedItem.status.length != 0) {
          if (searchedItem.status == "ALL") {
            setTableData(ven);
          } else {
            fetcheddata = ven.filter(
              (ele) => ele.available == searchedItem.status
            );
            setTableData(fetcheddata);
          }
        } else {
          console.log(ven, "inside else block of venre");
          setTableData(ven);
        }
      } //not working because vendor_id data is coming
      //two conditions
      else if (
        searchedItem.main_category.length != 0 &&
        searchedItem.sub_Category.length != 0
      ) {
        var sub = [];
        for (let i = 0; i < searchedItem.sub_Category.length; i++) {
          fetcheddata = assetsList.AssetsList.filter(
            (ele) => ele.sub_category_id == searchedItem.sub_Category[i]
          ).map((data) => sub.push(data));
        }
        if (searchedItem.status.length != 0) {
          if (searchedItem.status == "ALL") {
            setTableData(sub);
          } else {
            fetcheddata = sub.filter(
              (ele) => ele.available == searchedItem.status
            );
            setTableData(fetcheddata);
          }
        } else {
          console.log(sub, "inside else block of subre");
          setTableData(sub);
        }
        // setTableData(sub);
      } //working fine
      else if (
        searchedItem.main_category.length != 0 &&
        searchedItem.store.length != 0
      ) {
        console.log("inside store and main");
        var main = [];
        for (let i = 0; i < searchedItem.main_category.length; i++) {
          fetcheddata = assetsList?.AssetsList.filter(
            (ele) =>
              ele.maintenance_maincategory_id == searchedItem.main_category[i]
          ).map((data) => main.push(data));
        }
        var sto = [];
        for (let i = 0; i < searchedItem.store.length; i++) {
          fetcheddata = main
            .filter((ele) => ele.store_name == searchedItem.store[i])
            .map((data) => sto.push(data));
        }
        if (searchedItem.status.length != 0) {
          if (searchedItem.status == "ALL") {
            setTableData(sto);
          } else {
            fetcheddata = sto.filter(
              (ele) => ele.available == searchedItem.status
            );
            setTableData(fetcheddata);
          }
        } else {
          console.log(sto, "inside else block of store");
          setTableData(sto);
        }
        // setTableData(sto);
        console.log(sto, "inside store and main");
      } //working fine
      else if (
        searchedItem.main_category.length != 0 &&
        searchedItem.vendor.length != 0
      ) {
        var main = [];
        for (let i = 0; i < searchedItem.main_category.length; i++) {
          fetcheddata = assetsList?.AssetsList.filter(
            (ele) =>
              ele.maintenance_maincategory_id == searchedItem.main_category[i]
          ).map((data) => main.push(data));
        }
        var ven = [];
        for (let i = 0; i < searchedItem.vendor.length; i++) {
          fetcheddata = main
            .filter((ele) => ele.vendor_id == searchedItem.vendor[i])
            .map((data) => ven.push(data));
        }
        if (searchedItem.status.length != 0) {
          if (searchedItem.status == "ALL") {
            setTableData(ven);
          } else {
            fetcheddata = ven.filter(
              (ele) => ele.available == searchedItem.status
            );
            setTableData(fetcheddata);
          }
        } else {
          console.log(ven, "inside else block of venre");
          setTableData(ven);
        }
        console.log(ven, "vendorinfo");
        // setTableData(ven);
      } //not working because of vendor_id
      else if (
        searchedItem.vendor.length != 0 &&
        searchedItem.store.length != 0
      ) {
        var sto = [];
        for (let i = 0; i < searchedItem.store.length; i++) {
          fetcheddata = assetsList.AssetsList.filter(
            (ele) => ele.store_name == searchedItem.store[i]
          ).map((data) => sto.push(data));
        }
        var ven = [];
        for (let i = 0; i < searchedItem.vendor.length; i++) {
          fetcheddata = sto
            .filter((ele) => ele.vendor_id == searchedItem.vendor)
            .map((data) => ven.push(data));
        }
        if (searchedItem.status.length != 0) {
          if (searchedItem.status == "ALL") {
            setTableData(sto);
          } else {
            fetcheddata = sto.filter(
              (ele) => ele.available == searchedItem.status
            );
            setTableData(fetcheddata);
          }
        } else {
          console.log(sto, "inside else block of store");
          setTableData(sto);
        }
        setTableData(ven);
      } //not working because of vendor_id
      //single condition
      else if (searchedItem.vendor.length != 0) {
        console.log(searchedItem.vendor, "vendor");
        console.log(searchedItem.vendor.length, "vendor");
        console.log("inside vendor selection");
        var ven = [];
        for (let i = 0; i < searchedItem.vendor.length; i++) {
          console.log("inside for loop selection");
          fetcheddata = assetsList.AssetsList.filter(
            (ele) => ele.vendor_id == searchedItem.vendor[i]
          ).map((data) => ven.push(data));
          console.log(fetcheddata, "fetcheddata");
        }
        if (searchedItem.status.length != 0) {
          if (searchedItem.status == "ALL") {
            setTableData(ven);
          } else {
            fetcheddata = ven.filter(
              (ele) => ele.available == searchedItem.status
            );
            setTableData(fetcheddata);
          }
        } else {
          console.log(ven, "inside else block of store");
          setTableData(ven);
        }
        setTableData(ven);
      } //not working because of vendor_id is not there in api
      else if (searchedItem.store.length != 0) {
        console.log(searchedItem.status.length, "searchedItem.status.length");
        var sto = [];
        console.log(searchedItem.store);
        for (let i = 0; i < searchedItem.store.length; i++) {
          fetcheddata = assetsList.AssetsList.filter(
            (ele) => ele.store_name == searchedItem.store[i]
          ).map((data) => sto.push(data));
        }

        if (searchedItem.status.length != 0) {
          if (searchedItem.status == "ALL") {
            setTableData(sto);
          } else {
            fetcheddata = sto.filter(
              (ele) => ele.available == searchedItem.status
            );
            setTableData(fetcheddata);
          }
        } else {
          console.log(sto, "inside else block of store");
          setTableData(sto);
        }
        // setTableData(sto);
      } //working fine
      else if (searchedItem.main_category.length != 0) {
        var main = [];
        for (let i = 0; i < searchedItem.main_category.length; i++) {
          fetcheddata = assetsList?.AssetsList.filter(
            (ele) =>
              ele.maintenance_maincategory_id == searchedItem.main_category[i]
          ).map((data) => main.push(data));
        }
        if (searchedItem.status.length != 0) {
          if (searchedItem.status == "ALL") {
            setTableData(main);
          } else {
            fetcheddata = main.filter(
              (ele) => ele.available == searchedItem.status
            );
            setTableData(fetcheddata);
          }
        } else {
          console.log(main, "inside else block of store");
          setTableData(main);
        }
        // setTableData(main);
      } //working fine
      else if (searchedItem.status.length != 0) {
        if (searchedItem.status == "ALL") {
          var fetcheddata = assetsList?.AssetsList.filter((ele) => ele);
          setTableData(fetcheddata);
        } else {
          let statusData = assetsList?.AssetsList.filter(
            (ele) => ele.available == searchedItem.status
          );
          setTableData(statusData);
        }
      }
    }
  };
  const amcHandler = () => {
    setIsAmc(!isAmc);
  };

  useEffect(() => {
    dispatch(doGetAssetsList());
  }, []);

  useEffect(() => {
    setAssetImage(
      `${apiInterface}/displaystoreimages?info_row_id=${selectedAsset?.asset_id}&&type=2`
    );
  }, [selectedAsset?.asset_id]);

  return (
    <>
      {status?.isAssetList ? (
        <div>
          <div className="wrapper">
            <Header title={assetTitle} />
            <Menu />
            {status?.modalOpen && status?.message != undefined && (
              <MessageBox
                message={status?.message}
                onClose={() => {
                  if (status?.apiStatus) {
                    dispatch(doGetAssetsList());
                  }
                }}
              />
            )}
            <div className="content-wrapper">
              <Spinner isLoading={status?.loading}>
                <div>
                  {AllowAssets?.add_allow == 1 && (
                    <div className="m-btn-block">
                      <div className="m-btn-block__container">
                        <div className="m-btn-block__icon">
                          <i
                            className="fa fa-plus-circle"
                            aria-hidden="true"
                          ></i>
                        </div>
                        <div className="m-btn-block__btns">
                          <button
                            style={{ margin: "5px 0px", width: "100%" }}
                            type="submit"
                            onClick={_doNavToAddAsset}
                            className="btn btn-secondary deca-btn-yellow"
                          >
                            Create New Asset
                          </button>
                          <FileUploadModal
                            handleCancel={handleCancel}
                            visible={visible}
                            modalTitle={assetFileUploadModalTitle}
                            subTitle={assetFileUploadModalSubTitle}
                            fileType="excel"
                            uploadUrl={apiInterface4 + assetFileUploadApi}
                            fileList={fileList}
                            setFileList={setFileList}
                            additionalFormData={storeSelectedForBulkUpload}
                            setAdditionalFormData={setStoreSelectedForBulkUpload}
                            body={
                              <AssetBulkUploadBody
                                setSelectedStore={setStoreSelectedForBulkUpload}
                                selectedStore={storeSelectedForBulkUpload}
                                assetsList={assetsList}
                              />
                            }
                            height={"400px"}
                            width={700}
                          >
                            <button
                              style={{ margin: "5px 0px", width: "100%" }}
                              type="submit"
                              className="btn btn-secondary deca-btn-yellow"
                              onClick={openModal}
                            >
                              Bulk Asset upload
                            </button>
                          </FileUploadModal>
                        </div>
                      </div>
                    </div>
                  )}
                  <section className="content">
                    <div className="m-panel mt-10">
                      <div className="m-panel__body p10">
                        <div className="row">
                          <div className="col-md-2">
                            <div className="form-group select_h150">
                              <label htmlFor="exampleInput">Store</label>
                              <Select
                                className="form-control"
                                showSearch
                                mode="multiple"
                                onChange={(value) => {
                                  setSearchedItem({
                                    ...searchedItem,
                                    store: value,
                                  });
                                }}
                                value={searchedItem.store}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {" "}
                                {assetsList?.StoreList?.map((item) => (
                                  <Option
                                    key={item.store_id}
                                    value={item.store_name}
                                  >
                                    {item.store_name}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group select_h150">
                              <label htmlFor="exampleInput">
                                Main Category
                              </label>
                              <Select
                                className="form-control"
                                showSearch
                                mode="multiple"
                                placeholder="-- Please Select --"
                                onChange={(value) => {
                                  _doSelectVender(value);
                                  setSearchedItem({
                                    ...searchedItem,
                                    main_category: value,
                                  });
                                }}
                                value={searchedItem.main_category}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {" "}
                                {assetsList?.MainCategory?.map((item) => (
                                  <Option key={item.id} value={item.id}>
                                    {item.name}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group select_h150">
                              <label htmlFor="exampleInput">Sub Category</label>
                              <Select
                                className="form-control"
                                showSearch
                                mode="multiple"
                                onChange={(value) => {
                                  setSearchedItem({
                                    ...searchedItem,
                                    sub_Category: value,
                                  });
                                }}
                                value={searchedItem.sub_Category}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {" "}
                                {subCategory?.map((item) => (
                                  <Option key={item.id} value={item.id}>
                                    {item.name}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group select_h150">
                              <label htmlFor="exampleInput">Vendor</label>
                              <Select
                                className="form-control"
                                showSearch
                                mode="multiple"
                                onChange={(value) => {
                                  setSearchedItem({
                                    ...searchedItem,
                                    vendor: value,
                                  });
                                }}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                value={searchedItem.vendor}
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {" "}
                                {assetsList?.VendorList?.map((item) => (
                                  <Option
                                    key={item.vendor_id}
                                    value={item.vendor_id}
                                  >
                                    {item.vendor_company_name}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <label htmlFor="exampleInput">Availability</label>
                              <Select
                                className="form-control"
                                showSearch
                                onChange={(value) => {
                                  setSearchedItem({
                                    ...searchedItem,
                                    status: value,
                                  });
                                }}
                                placeholder="-- Please Select --"
                                optionFilterProp="children"
                                value={
                                  searchedItem.status.length == 0
                                    ? "-- Please Select --"
                                    : searchedItem.status
                                }
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {" "}
                                <Option value="ALL">ALL</Option>
                                <Option value="AVAILABLE">AVAILABLE</Option>
                                <Option value="NOT AVAILABLE">
                                  NOT AVAILABLE
                                </Option>
                              </Select>
                            </div>
                          </div>

                          <div className="col-md-1 btn-no-lbl">
                            <button
                              type="submit"
                              className="btn btn-secondary btn-icon deca-btn-yellow"
                              onClick={handleSearch}
                            >
                              <i className="fa fa-search"></i>
                            </button>
                          </div>
                          <div className="col-md-2 btn-no-lbl">
                            <button
                              className="btn btn-secondary deca-btn-yellow"
                              onClick={() => exportToExcel(tableData)}
                            >
                              Export to Excel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="m-panel">
                      <div className="m-panel__body p10 pb-10">
                        <div className="row">
                          <div className="col-md-8">
                            <div className="m-table__main">
                              <div className="m-table__responsive medium-width has-action-column single">
                                <Table
                                  rowKey="asset_id"
                                  columns={TableColumns}
                                  dataSource={tableData}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="m-panel">
                              <div className="m-panel__body bg-dark">
                                <div className="row">
                                  <div className="col-md-12 text-center">
                                    <div className="">
                                      <div className="asset_image_wrapper">
                                        <img src={assetImage} />
                                        <label>
                                          <i
                                            className="fa fa-camera camera_icon_asset"
                                            aria-hidden="true"
                                          ></i>
                                          <input
                                            type="file"
                                            id="file"
                                            style={{ display: "none" }}
                                            name="image"
                                            accept="image/gif,image/jpeg,image/jpg,image/png"
                                            data-original-title="upload photos"
                                            onChange={(e) =>
                                              handleFileUpload(
                                                e.target.files[0]
                                              )
                                            }
                                          />
                                        </label>
                                      </div>
                                      <h5 className="c-pic__title">
                                        {selectedAsset?.asset_name}
                                      </h5>
                                    </div>
                                  </div>
                                  <div></div>

                                  <div className="col-md-12">
                                    <h3 className="m-panel__subtitle">
                                      Asset Information
                                    </h3>
                                    <p className="m-info-panel__text asset-list">
                                      Asset Sub Category :{" "}
                                      {selectedAsset?.sub_category_name}
                                    </p>
                                    <p className="m-info-panel__text asset-list">
                                      Asset Name : {selectedAsset?.asset_name}
                                    </p>
                                    <p className="m-info-panel__text asset-list">
                                      Asset Ref# : {selectedAsset?.asset_ref}
                                    </p>
                                    <p className="m-info-panel__text asset-list">
                                      Availablility : {selectedAsset?.available}
                                    </p>

                                    {selectedAsset?.location && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Location : {selectedAsset?.location}
                                      </p>
                                    )}
                                    {selectedAsset?.make && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Make : {selectedAsset?.make}
                                      </p>
                                    )}
                                    {selectedAsset?.model_no && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Model No : {selectedAsset?.model_no}
                                      </p>
                                    )}
                                    {selectedAsset?.serial_no && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Serial No : {selectedAsset?.serial_no}
                                      </p>
                                    )}
                                    {selectedAsset?.capacity_type && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Capacity Type :{" "}
                                        {selectedAsset?.capacity_type}
                                      </p>
                                    )}
                                    {selectedAsset?.capacity_value && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Capacity Value :{" "}
                                        {selectedAsset?.capacity_value}
                                      </p>
                                    )}
                                    {selectedAsset?.installation_date && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Installation Date :{" "}
                                        {selectedAsset?.installation_date}
                                      </p>
                                    )}
                                    {selectedAsset?.warranty && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Warranty : {selectedAsset?.warranty}
                                      </p>
                                    )}
                                    {selectedAsset?.installation_by && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Installation By :{" "}
                                        {selectedAsset?.installation_by}
                                      </p>
                                    )}
                                    {selectedAsset?.maintenance_year_1 && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Maintenance Year 1 :{" "}
                                        {selectedAsset?.maintenance_year_1}
                                      </p>
                                    )}
                                    {selectedAsset?.maintenance_after_year_1 && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Maintenance After Year 1 :{" "}
                                        {
                                          selectedAsset?.maintenance_after_year_1
                                        }
                                      </p>
                                    )}
                                    {selectedAsset?.repair_works && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Repair Works :{" "}
                                        {selectedAsset?.repair_works}
                                      </p>
                                    )}
                                    {selectedAsset?.reinvestment && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Reinvestment :{" "}
                                        {selectedAsset?.reinvestment}
                                      </p>
                                    )}
                                    {selectedAsset?.life_of_asset && (
                                      <p className="m-info-panel__text asset-list">
                                        {" "}
                                        Life of Asset :{" "}
                                        {selectedAsset?.life_of_asset}
                                      </p>
                                    )}
                                  </div>
                                  <div className="col-md-12">
                                    <h3
                                      className="m-panel__subtitle"
                                      style={{ cursor: "pointer" }}
                                      onClick={amcHandler}
                                    >
                                      AMC Details
                                    </h3>
                                    {isAmc && (
                                      <div className="m-info-panel__item asset-list">
                                        <p className="m-info-panel__text asset-list">
                                          Vendor Name :{" "}
                                          {selectedAsset?.vendor_company_name}
                                        </p>
                                        <p className="m-info-panel__text asset-list">
                                          Contact Number :
                                          {selectedAsset?.mobile_number1}{" "}
                                        </p>
                                        <p className="m-info-panel__text asset-list">
                                          Email Id :{" "}
                                          {selectedAsset?.email_address1}
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </Spinner>
            </div>
            <Footer />
          </div>
        </div>
      ) : null}
      {status?.isAssetCreate && <AddAsset />}
      {status?.isAssetEdit && <EditAsset />}
    </>
  );
}
